import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { SupplierSearchParams } from "./-data/schema";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";
import { ListSuppliersResponse } from "@/gen/suppliers/list_suppliers_pb";

export const Route = createFileRoute("/(pharma)/_layout/suppliers/")({
  component: Component,
  validateSearch: SupplierSearchParams,
});